export const patient_responsibility = {
  PI: [204],
  CO: [51]
};

export const denied_codes = {
  // CO: ['B7', '24', '22', '256'],
  OA: ['B11'],
  PI: ['252']
};

export const provider_responsibility = {
  CO: [29]
};
